import { render, staticRenderFns } from "./Position.vue?vue&type=template&id=b933d1b0&scoped=true&"
import script from "./Position.vue?vue&type=script&lang=js&"
export * from "./Position.vue?vue&type=script&lang=js&"
import style0 from "./Position.vue?vue&type=style&index=0&id=b933d1b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b933d1b0",
  null
  
)

export default component.exports